export default {
    status: {
        acknowledged: "Encomendado",
        created: "Criado",
        sent: "Encomendado",
        confirmed: "Encomendado",
        not_confirmed: "Não encomendado",
        delivery_email: "Enviado",
        delivery_rejected: "Exceção de entrega",
        delivery_rejected_not_confirmed: "Exceção de entrega",
        shipped: "Enviado",
        delayed: "Atrasado",
        preparing: "Preparando",
        processing: "Processamento",
        processed: "Processado",
        submitted: "Encomendado",
        delivery_not_received: "Enviado",
        shipment_exception: "Enviado",
        pre_pending_approval: "Pendente",
        pending_approval: "Pendente",
        approved: "Aprovado",
        not_approved: "Não aprovado",
        canceled: "Cancelado",
        returned: "Devolvido",
        lost_shipment: "Remessa perdida",
        delivery_not_confirmed: "Entregue",
        delivered: "Entregue",
        delivery_received: "Entregue",
        refurbished: "Retorno concluído",
        returned_to_office: "Retornou ao cargo",
        return_to_employer: "Devolvido ao Empregador",
        return_pickup_scheduled: "Retirada agendada",
        return_pickup_completed: "Retirada concluída",
        return_pickup_excluded: "Retirada excluída",
        return_pickup_submitted: "Retirada enviada",
        return_pickup_finalized: "Retirada finalizada",
        disposed: "Descartado",
        damaged: "Danificado",
        transferred: "Transferido",
        transfer_received: "Transferência Recebida"
    }
}